<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Gadai Emas</h5>
            </template>
            <b-alert variant="primary" show>* Sedang dalam verifikasi AM</b-alert>
            <b-form @submit.prevent="openModalConfirm">
                <div class="detail-data-wrapper mb-4">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                        <b-col v-if="dataStagingEmas.noFaktur != null"><strong>{{ dataStagingEmas.noFaktur }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                        <b-col v-if="dataStagingEmas.statusGadai != null">{{ dataStagingEmas.statusGadai }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                        <b-col v-if="dataStagingEmas.anggota.noAnggota != null"><strong>{{ dataStagingEmas.anggota.noAnggota }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                        <b-col v-if="dataStagingEmas.anggota.jenisIdentitas != null">{{ dataStagingEmas.anggota.jenisIdentitas }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                        <b-col v-if="dataStagingEmas.anggota.noIdentitas != null">{{ dataStagingEmas.anggota.noIdentitas }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama</b-col>
                        <b-col v-if="dataStagingEmas.anggota.namaAnggota != null">{{ dataStagingEmas.anggota.namaAnggota }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. HP</b-col>
                        <b-col v-if="dataStagingEmas.anggota.noHp != null">{{ dataStagingEmas.anggota.noHp }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Rumah</b-col>
                        <b-col v-if="dataStagingEmas.anggota.noRumah != null">{{ dataStagingEmas.anggota.noRumah }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat</b-col>
                        <b-col v-if="dataStagingEmas.anggota.alamat != null">{{ dataStagingEmas.anggota.alamat }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA BARANG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataStagingEmas.barangLama.jenis.name != null">{{ dataStagingEmas.barangLama.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataStagingEmas.barangLama.merk.name != null">{{ dataStagingEmas.barangLama.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataStagingEmas.barangLama.tipe.name != null">{{ dataStagingEmas.barangLama.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
							<div class="mb-2">
                                <div class="detail-data-label">Berat</div>
                                <div v-if="dataStagingEmas.barangLama.berat != null">{{ dataStagingEmas.barangLama.berat }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataStagingEmas.barangLama.keterangan != null && dataStagingEmas.barangLama.keterangan != 'null'">{{ dataStagingEmas.barangLama.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataStagingEmas.barangLama.spesifikasi.length >=1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataStagingEmas.barangLama.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataStagingEmas.barangBaru.jenis.name != null">{{ dataStagingEmas.barangBaru.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataStagingEmas.barangBaru.merk.name != null">{{ dataStagingEmas.barangBaru.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataStagingEmas.barangBaru.tipe.name != null">{{ dataStagingEmas.barangBaru.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
							<div class="mb-2">
                                <div class="detail-data-label">Berat</div>
                                <div v-if="dataStagingEmas.barangBaru.berat != null">{{ dataStagingEmas.barangBaru.berat }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataStagingEmas.barangBaru.keterangan != null && dataStagingEmas.barangBaru.keterangan != 'null'">{{ dataStagingEmas.barangBaru.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataStagingEmas.barangBaru.spesifikasi.length >=1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataStagingEmas.barangBaru.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataStagingEmas.fotoLama)">
                                    <span class="mr-1" v-for="(item, idx) in dataStagingEmas.fotoLama"  v-bind:key="idx">
                                        <a v-bind:href="item.name" target="_blank">
                                            <img width="150px" :src="item.name" alt="Foto Pendukung">
                                        </a>
                                    </span>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataStagingEmas.fotoBaru)">
                                    <span class="mr-1" v-for="(item, idx) in dataStagingEmas.fotoBaru"  v-bind:key="idx">
                                        <a v-bind:href="item.name" target="_blank">
                                            <img width="150px" :src="item.name" alt="Foto Pendukung">
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Keterangan</b-col>
                        <b-col v-if="dataStagingEmas.keterangan != null">{{ dataStagingEmas.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Diajukan pada</b-col>
                        <b-col>{{ $helper.changeDateFormat(dataStagingEmas.createdAt )}} {{ $helper.changeDateFormatGetHour(dataStagingEmas.createdAt )}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Diajukan oleh</b-col>
                        <b-col>{{ dataStagingEmas.createdBy }}</b-col>
                    </b-row>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>

export default {
    name: 'edit-gadai-emas',
    data(){
        return{
            initStatus: 0,
            dataStagingEmas: []
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            
            let getEditStagingEmas = this.$axios.get(`gadai/daftar-gadai/${this.id}/staging`).then(response => {
                this.dataStagingEmas = response.data
    
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getEditStagingEmas]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                const noFaktur = this.$route.path.split('/')[3];
                const message = this.$helper.parseError(this, error, '', false)
                if (message == 'Gadai ini tidak dalam verifikasi edit - tidak dapat menampilkan data!') {
                    this.$router.push(`/gadai/inquiry-faktur/${noFaktur}`);
                }
                this.initStatus = -1
            })
        },

        
    },
    created(){
        this.init()
    }
}
</script>
